<!-- ================管理端-五馆配置====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">五馆配置列表</div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">所属五馆:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="changeMuseum"
                               v-model="queryParams.museumKey" placeholder="请选择">
                        <el-option v-for="item in museumList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">主题类别:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.parentId" placeholder="请选择">
                        <el-option v-for="item in classifyList" :key="item.itemId" :label="item.itemName"
                                   :value="item.itemId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.itemName" placeholder="请输入主题名称" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 225px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="120" label="封面" align="center" prop="itemCover">
                    <template #default="scope">
                        <el-image v-if="scope.row.itemCover" :src="scope.row.itemCover" fit="cover"
                                  style="width: 80px; height: 45px;" />
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="主题名称" align="center" prop="itemName">
                    <template #default="scope">
                        <div :title="scope.row.itemName" class="text-one">
                            {{ scope.row.itemName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" label="所属五馆" align="center" prop="museumName">
                    <template #default="scope">
                        <div :title="museumName(scope.row)" class="text-one">
                            {{ museumName(scope.row) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="主题简介" align="center" prop="itemClassify" />
                <el-table-column width="100" fixed="right"  align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-button type="primary" size="default" @click="handleCover(scope.row)">封面</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
        <!--  上传封面弹窗  -->
        <el-dialog v-model="coverDialogVisible" title="上传封面" width="500px"
                   :close-on-click-modal="false" append-to-body>
            <div class="cover-dialog-name" :title="coverForm.itemName">主题名称：{{ coverForm.itemName }}</div>
            <el-upload class="cover-uploader"
                       :action="serviceUrl + '/businessservice/humanityItem/uploadCover'"
                       :data="{ itemId: coverForm.itemId }"
                       :headers="{ token }"
                       accept="image/*"
                       :show-file-list="false"
                       :before-upload="beforeCoverUpload"
                       :on-success="handleCoverSuccess">
                <img alt="" v-if="coverForm.itemCover" :src="coverForm.itemCover" class="cover-image" />
                <el-icon v-else class="cover-uploader-icon"><Plus /></el-icon>
            </el-upload>
            <div class="cover-dialog-tip">只允许上传图片文件，大小不超过10M。</div>
        </el-dialog>
    </div>

</template>
<script>
import {pageHumanityItem, queryClassifyList} from "@/api/admin/humanityItem";
import {queryDict} from "@/api/admin/dict";
import {serviceUrl} from "@/utils/global";

export default {
    components: {},
    name: "museumConfig",
    data() {
        return {
            serviceUrl,
            loading: false,
            /*分页查询五馆配置*/
            queryParams:{
                museumKey:'',
                parentId:'',
                itemName:'',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            museumList:[],
            classifyList:[],
            /*封面上传*/
            token: this.$storage.get("token"),
            coverDialogVisible: false,
            coverForm:{
                itemId:'',
                itemName:'',
                itemCover:'',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageList();
        this.handleQueryDict();
    },
    mounted() {},
    methods: {
        /*===========数据查询============*/
        changeMuseum(){
            this.queryParams.parentId = '';
            this.classifyList = [];
            this.pageList(null);
            if (this.queryParams.museumKey){
                this.handleQueryClassify();
            }
        },
        handleQueryDict() {
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                }
            })
        },
        /*查询主题类别，跟随五馆切换*/
        handleQueryClassify(){
            queryClassifyList({
                itemName: '',
                museumKey: this.queryParams.museumKey,
            }).then(res => {
                if (res.data.code === 1) {
                    this.classifyList = res.data.data;
                }else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            })
        },
        museumName(row){
            if (row.museumName){
                return row.museumName;
            }
            const museum = this.museumList.find(item => item.dictKey === row.museumKey);
            return museum ? museum.dictValue : '';
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageHumanityItem(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error(res.data.msg || "请求出错")
                    this.loading = false;
                }
            }).catch(() => {
                this.loading = false;
            })
        },
        /*===========封面上传============*/
        handleCover(row){
            this.coverForm.itemId = row.itemId;
            this.coverForm.itemName = row.itemName;
            this.coverForm.itemCover = row.itemCover;
            this.coverDialogVisible = true;
        },
        beforeCoverUpload(rawFile){
            if (!rawFile.type.startsWith('image/')) {
                this.$message.error('只允许上传图片文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleCoverSuccess(response, uploadFile){
            if (uploadFile.response.code === 1) {
                this.$message.success("上传成功");
                this.coverDialogVisible = false;
                this.pageList(null);
            } else {
                this.$message.error(uploadFile.response.msg || "上传失败")
            }
        },
    },
}
</script>
<style scoped>
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}
.cover-dialog-name{
    margin-bottom: 15px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cover-uploader /deep/ .el-upload{
    width: 100%;
    height: 200px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cover-uploader /deep/ .el-upload:hover{
    border-color: #377f7f;
}
.cover-uploader-icon{
    font-size: 40px;
    color: #8c939d;
}
.cover-image{
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
}
.cover-dialog-tip{
    margin-top: 10px;
    color: #a9abad;
}

</style>
